import React, { Component } from "react";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import AgencyContainer from "../../components/agent/agency/AgencyContainer";

class AgentConsultant extends Component {
    render() {
        return (
            <main>
                <Header />
                <Sidebar />
                <MainContainer>
                    <AgencyContainer />
                </MainContainer>
            </main>
        );
    }
}

export default AgentConsultant;
